import CloseIcon from "@mui/icons-material/Close";
import {
	Chip,
	Dialog,
	DialogContent,
	DialogTitle,
	IconButton,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { LoadingComp } from "../../../../shared/components/loading/Loading";
import { IAgreement, SinisterAgreementService } from "../../../../shared/services/api/sinister/SinisterAgreementService";
import { formatDateFnsRemoveTimezone } from "../../../../shared/utils/format-date";
import { formatScaleValueBR } from "../../../../shared/utils/formatScaleValue";
import { getInstallmentStatusChipColors, getInstallmentStatusLabel } from "../../constants/installmentStatusOptions";
import { InstallmentRowMenu } from "../InstallmentRowMenu";

interface Props {
	open: boolean;
	agreementId: string;
	onClose: () => void;
}

export const ModalAgreementInstallments = ({ open, agreementId, onClose }: Props) => {
	const [agreement, setAgreement] = useState<IAgreement | null>(null);
	const [isLoading, setIsLoading] = useState(false);

	const fetchAgreement = () => {
		setIsLoading(true);
		SinisterAgreementService.getById(agreementId).then((result) => {
			if (!(result instanceof Error)) setAgreement(result);
			setIsLoading(false);
		});
	};

	useEffect(() => {
		if (open) fetchAgreement();
	}, [open, agreementId]);

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				<Typography variant="h6" color="primary" sx={{ fontWeight: 400 }}>
					Parcelas do Acordo
				</Typography>
				<IconButton onClick={onClose} size="small">
					<CloseIcon fontSize="small" />
				</IconButton>
			</DialogTitle>

			<DialogContent dividers>
				<LoadingComp isopen={isLoading} />
				{agreement && (
					<TableContainer>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell>Parcela</TableCell>
									<TableCell align="center">Vencimento</TableCell>
									<TableCell align="right">Valor</TableCell>
									<TableCell align="center">Status</TableCell>
									<TableCell align="center">Ações</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{agreement.installments.map((installment) => {
									const colors = getInstallmentStatusChipColors(installment.status);
									return (
										<TableRow key={installment.number}>
											<TableCell>
												{installment.number}
												{!!installment.reissueCount && (
													<Typography component="span" variant="caption" color="text.secondary" ml={0.5}>
														({installment.reissueCount + 1}ª via)
													</Typography>
												)}
											</TableCell>
											<TableCell align="center">{formatDateFnsRemoveTimezone(installment.dueDate) || "-"}</TableCell>
											<TableCell align="right">{formatScaleValueBR(String(installment.value))}</TableCell>
											<TableCell align="center">
												<Chip
													size="small"
													label={getInstallmentStatusLabel(installment.status)}
													sx={{ bgcolor: colors.bg, color: colors.color, fontWeight: 500 }}
												/>
											</TableCell>
											<TableCell align="center">
												<InstallmentRowMenu agreement={agreement} installment={installment} onChanged={fetchAgreement} />
											</TableCell>
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
				)}
			</DialogContent>
		</Dialog>
	);
};
